// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-form-item--small.el-form-item[data-v-29053955] {\n\tmargin-bottom: 1px;\n\twidth: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
